import { gql } from '@apollo/client';

export const GET_LOCATION = gql`
  query GetLocation(
    $locationId: ID!
    $contextualCountry: String
    $language: LanguageCodeIso
  ) {
    location(
      id: $locationId
      contextualCountry: $contextualCountry
      language: $language
    ) {
      id
      country
      type
      description
      displayDescription
    }
  }
`;
